"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AlertFeedback", {
  enumerable: true,
  get: function get() {
    return _AlertFeedback.default;
  }
});
Object.defineProperty(exports, "AudioPlayer", {
  enumerable: true,
  get: function get() {
    return _AudioPlayer.default;
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _DesignComponents.Button;
  }
});
Object.defineProperty(exports, "CompletionStatusContext", {
  enumerable: true,
  get: function get() {
    return _CompletionStatusContext.default;
  }
});
Object.defineProperty(exports, "ComponentTest", {
  enumerable: true,
  get: function get() {
    return _ComponentTest.default;
  }
});
Object.defineProperty(exports, "DesignRow", {
  enumerable: true,
  get: function get() {
    return _DesignComponents.DesignRow;
  }
});
Object.defineProperty(exports, "DndProvider", {
  enumerable: true,
  get: function get() {
    return _DndProvider.default;
  }
});
Object.defineProperty(exports, "Figure", {
  enumerable: true,
  get: function get() {
    return _Figure.default;
  }
});
Object.defineProperty(exports, "FigureList", {
  enumerable: true,
  get: function get() {
    return _FigureList.default;
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _Image.default;
  }
});
Object.defineProperty(exports, "ModalFeedback", {
  enumerable: true,
  get: function get() {
    return _ModalFeedback.default;
  }
});
Object.defineProperty(exports, "Navigation", {
  enumerable: true,
  get: function get() {
    return _Navigation.default;
  }
});
Object.defineProperty(exports, "NavigationArrows", {
  enumerable: true,
  get: function get() {
    return _NavigationArrows.default;
  }
});
Object.defineProperty(exports, "Page", {
  enumerable: true,
  get: function get() {
    return _Page.default;
  }
});
Object.defineProperty(exports, "Paragraph", {
  enumerable: true,
  get: function get() {
    return _DesignComponents.Paragraph;
  }
});
Object.defineProperty(exports, "ShrinkToFit", {
  enumerable: true,
  get: function get() {
    return _ShrinkToFit.default;
  }
});
exports.Stage = void 0;
Object.defineProperty(exports, "Storage", {
  enumerable: true,
  get: function get() {
    return _Storage.default;
  }
});
Object.defineProperty(exports, "TaskAnimation", {
  enumerable: true,
  get: function get() {
    return _TaskAnimation.default;
  }
});
Object.defineProperty(exports, "TaskBlank", {
  enumerable: true,
  get: function get() {
    return _TaskBlank.default;
  }
});
Object.defineProperty(exports, "TaskButton", {
  enumerable: true,
  get: function get() {
    return _TaskButton.default;
  }
});
Object.defineProperty(exports, "TaskCallout", {
  enumerable: true,
  get: function get() {
    return _TaskCallout.default;
  }
});
Object.defineProperty(exports, "TaskCarousel", {
  enumerable: true,
  get: function get() {
    return _TaskCarousel.default;
  }
});
Object.defineProperty(exports, "TaskChordBuilder", {
  enumerable: true,
  get: function get() {
    return _TaskChordBuilder.default;
  }
});
Object.defineProperty(exports, "TaskCustom", {
  enumerable: true,
  get: function get() {
    return _TaskCustom.default;
  }
});
Object.defineProperty(exports, "TaskDragDrop", {
  enumerable: true,
  get: function get() {
    return _TaskDragDrop.default;
  }
});
Object.defineProperty(exports, "TaskExternal", {
  enumerable: true,
  get: function get() {
    return _TaskExternal.default;
  }
});
Object.defineProperty(exports, "TaskFreeResponse", {
  enumerable: true,
  get: function get() {
    return _TaskFreeResponse.default;
  }
});
Object.defineProperty(exports, "TaskGraphSlider", {
  enumerable: true,
  get: function get() {
    return _TaskGraphSlider.default;
  }
});
Object.defineProperty(exports, "TaskImageClick", {
  enumerable: true,
  get: function get() {
    return _TaskImageClick.default;
  }
});
Object.defineProperty(exports, "TaskLikertScale", {
  enumerable: true,
  get: function get() {
    return _TaskLikertScale.default;
  }
});
Object.defineProperty(exports, "TaskMultiChoice", {
  enumerable: true,
  get: function get() {
    return _TaskMultiChoice.default;
  }
});
Object.defineProperty(exports, "TaskMultiChoiceButton", {
  enumerable: true,
  get: function get() {
    return _TaskMultiChoiceButton.default;
  }
});
Object.defineProperty(exports, "TaskMultiSelect", {
  enumerable: true,
  get: function get() {
    return _TaskMultiSelect.default;
  }
});
Object.defineProperty(exports, "TaskMultiSelectButton", {
  enumerable: true,
  get: function get() {
    return _TaskMultiSelectButton.default;
  }
});
exports.TaskMultiSelectSubmit = void 0;
Object.defineProperty(exports, "TaskMusicViewer", {
  enumerable: true,
  get: function get() {
    return _TaskMusicViewer.default;
  }
});
Object.defineProperty(exports, "TaskPassageClick", {
  enumerable: true,
  get: function get() {
    return _TaskPassageClick.default;
  }
});
Object.defineProperty(exports, "TaskPassageReveal", {
  enumerable: true,
  get: function get() {
    return _TaskPassageReveal.default;
  }
});
Object.defineProperty(exports, "TaskRank", {
  enumerable: true,
  get: function get() {
    return _TaskRank.default;
  }
});
Object.defineProperty(exports, "TaskScaleBuilder", {
  enumerable: true,
  get: function get() {
    return _TaskScaleBuilder.default;
  }
});
Object.defineProperty(exports, "TaskSelect", {
  enumerable: true,
  get: function get() {
    return _TaskSelect.default;
  }
});
Object.defineProperty(exports, "TaskSlider", {
  enumerable: true,
  get: function get() {
    return _TaskSlider.default;
  }
});
Object.defineProperty(exports, "TaskSorting", {
  enumerable: true,
  get: function get() {
    return _TaskSorting.default;
  }
});
Object.defineProperty(exports, "TaskTabPanel", {
  enumerable: true,
  get: function get() {
    return _TaskTabPanel.default;
  }
});
Object.defineProperty(exports, "TaskTest", {
  enumerable: true,
  get: function get() {
    return _TaskTest.default;
  }
});
Object.defineProperty(exports, "TaskTree", {
  enumerable: true,
  get: function get() {
    return _TaskTree.default;
  }
});
Object.defineProperty(exports, "TaskTrueFalse", {
  enumerable: true,
  get: function get() {
    return _TaskTrueFalse.default;
  }
});
Object.defineProperty(exports, "TaskVoiceBuilder", {
  enumerable: true,
  get: function get() {
    return _TaskVoiceBuilder.default;
  }
});
Object.defineProperty(exports, "alphaNumericSort", {
  enumerable: true,
  get: function get() {
    return _util.alphaNumericSort;
  }
});
Object.defineProperty(exports, "clearStorage", {
  enumerable: true,
  get: function get() {
    return _Storage.clearStorage;
  }
});
Object.defineProperty(exports, "getWWNDS", {
  enumerable: true,
  get: function get() {
    return _DesignComponents.getWWNDS;
  }
});
Object.defineProperty(exports, "setWWNDS", {
  enumerable: true,
  get: function get() {
    return _DesignComponents.setWWNDS;
  }
});

var _util = require("./util");

var _DesignComponents = require("./DesignComponents/DesignComponents");

var _AlertFeedback = _interopRequireDefault(require("./AlertFeedback/AlertFeedback"));

var _AudioPlayer = _interopRequireDefault(require("./AudioPlayer/AudioPlayer"));

var _ComponentTest = _interopRequireDefault(require("./ComponentTest/ComponentTest"));

var _DndProvider = _interopRequireDefault(require("./DndProvider"));

var _Figure = _interopRequireDefault(require("./Figure/Figure"));

var _FigureList = _interopRequireDefault(require("./FigureList/FigureList"));

var _Image = _interopRequireDefault(require("./Image/Image"));

var _ModalFeedback = _interopRequireDefault(require("./ModalFeedback/ModalFeedback"));

var _Navigation = _interopRequireDefault(require("./Navigation/Navigation"));

var _NavigationArrows = _interopRequireDefault(require("./NavigationArrows/NavigationArrows"));

var _Page = _interopRequireDefault(require("./Page/Page"));

var _ShrinkToFit = _interopRequireDefault(require("./ShrinkToFit/ShrinkToFit"));

var _Storage = _interopRequireWildcard(require("./Storage"));

var _TaskAnimation = _interopRequireDefault(require("./TaskAnimation/TaskAnimation"));

var _TaskBlank = _interopRequireDefault(require("./TaskBlank/TaskBlank"));

var _TaskButton = _interopRequireDefault(require("./TaskButton/TaskButton"));

var _TaskCallout = _interopRequireDefault(require("./TaskCallout/TaskCallout"));

var _TaskCarousel = _interopRequireDefault(require("./TaskCarousel/TaskCarousel"));

var _TaskChordBuilder = _interopRequireDefault(require("./TaskScaleBuilder/TaskChordBuilder"));

var _TaskCustom = _interopRequireDefault(require("./TaskCustom/TaskCustom"));

var _TaskDragDrop = _interopRequireDefault(require("./TaskDragDrop/TaskDragDrop"));

var _TaskExternal = _interopRequireDefault(require("./TaskExternal/TaskExternal"));

var _TaskFreeResponse = _interopRequireDefault(require("./TaskFreeResponse/TaskFreeResponse"));

var _TaskGraphSlider = _interopRequireDefault(require("./TaskGraphSlider/TaskGraphSlider"));

var _TaskImageClick = _interopRequireDefault(require("./TaskImageClick/TaskImageClick"));

var _TaskLikertScale = _interopRequireDefault(require("./TaskLikertScale/TaskLikertScale"));

var _TaskMultiChoice = _interopRequireDefault(require("./TaskMultiChoice/TaskMultiChoice"));

var _TaskMultiChoiceButton = _interopRequireDefault(require("./TaskMultiChoiceButton/TaskMultiChoiceButton"));

var _TaskMultiSelect = _interopRequireDefault(require("./TaskMultiSelect/TaskMultiSelect"));

var _TaskMultiSelectButton = _interopRequireDefault(require("./TaskMultiSelectButton/TaskMultiSelectButton"));

var _TaskMusicViewer = _interopRequireDefault(require("./TaskScaleBuilder/TaskMusicViewer"));

var _TaskPassageClick = _interopRequireDefault(require("./TaskPassageClick/TaskPassageClick"));

var _TaskPassageReveal = _interopRequireDefault(require("./TaskPassageReveal/TaskPassageReveal"));

var _TaskRank = _interopRequireDefault(require("./TaskRank/TaskRank"));

var _TaskScaleBuilder = _interopRequireDefault(require("./TaskScaleBuilder/TaskScaleBuilder"));

var _TaskSelect = _interopRequireDefault(require("./TaskSelect/TaskSelect"));

var _TaskSlider = _interopRequireDefault(require("./TaskSlider/TaskSlider"));

var _TaskSorting = _interopRequireDefault(require("./TaskSorting/TaskSorting"));

var _TaskTabPanel = _interopRequireDefault(require("./TaskTabPanel/TaskTabPanel"));

var _TaskTest = _interopRequireDefault(require("./TaskTest/TaskTest"));

var _TaskTree = _interopRequireDefault(require("./TaskTree/TaskTree"));

var _TaskTrueFalse = _interopRequireDefault(require("./TaskTrueFalse/TaskTrueFalse"));

var _TaskVoiceBuilder = _interopRequireDefault(require("./TaskScaleBuilder/TaskVoiceBuilder"));

var _CompletionStatusContext = _interopRequireDefault(require("./CompletionStatusContext"));

require("bootstrap/dist/css/bootstrap.min.css");

require("react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css");

require("./index.scss");

var Stage = _Page.default;
exports.Stage = Stage;
var TaskMultiSelectSubmit = _TaskMultiSelectButton.default;
exports.TaskMultiSelectSubmit = TaskMultiSelectSubmit;